import { Component, OnInit, ViewChild, ElementRef, TemplateRef } from '@angular/core'
import { sla, kpiRelease, quater, year, kpi, slaperformance, filecontent } from './../../../models/slakpi';
import { division } from './../../../models/admin';
import { UtilityService } from './../../../services/utility.service';
import { SLAKPIApiService } from './../../../services/slakpi.service';
import { AdminApiService } from './../../../services/admin.service';
import { UserService } from './../../../services/user.service';
import { SpinnerVisibilityService } from 'ng-http-loader';

import { Router, ActivatedRoute, Params } from '@angular/router';
import { KPIAllHistoryComponent } from './../../../component/slakpi/kpi-allhistory/kpi-allhistory.component';
import { uniqBy } from 'lodash';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToasterService } from '../../../toaster.service';
@Component({
  selector: 'app-sla-performance.component',
  templateUrl: './sla-performance.component.html',
  styleUrls: ['./sla-performance.component.css']

})
export class SLAPerformanceComponent implements OnInit {
  public sli_data: any;
  public slaPerformance_data: any;
  public yearData: any;
  public quaterData: any;
  public division_data: any;
  public frequency_data: any;
  public resettype_data: any;
  public slaUno?: any=0;
  public yearUno?: any=0;
  public quarterUno?: any=0;
  public divisionUno?: any=0;
  public frequencyUno?: any=0;  
  public objkpiRelease: kpiRelease;
  public isback: boolean = false;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  public loading: boolean = true;
  angularGrid: AngularGridInstance;
  dataset: any;

  user: any = {};
  login_UserID: string; // number
  currentYear?: number;
  currentHalf?: number;
  currentQuarter?: number;
  currentMonth?: number;
  wellperformKPIRange?: number;
  isToggle: boolean = false;

  //for Users Permission
  public permision_add: boolean = false;
  public permision_edit: boolean = false;
  public permision_delete: boolean = false;

  isAdmin: boolean = false;

  public Qyearsla: number = 0;
  public Qquatersla: number = 0;
  public Qdivisionsla: number = 0;
  public QPerformance: number = 0;

  //for KPI All Hisory Dialog

  public kpiUnoSelected: number = 0;
  public kpinameSelected: string = '';
  //@ViewChild('KPIAllHistoryDialog', { static: false }) KPIAllHistoryDialog: DialogComponent;
  public position_history: object = { X: 70, Y: 100 };
    searchText: string;
    dataSearch: any[];
  noDataImg: any;
  tenantUno: any;
    isDigitalDewa: boolean=false;
    selectedSLAUno: any;
   
  @ViewChild('attachmentTemplate', { static: false }) attachmentTemplate: TemplateRef<any>;
  AttachmentList: any = [];
  fileItemCount: number = 0;
  modalRef: any;
    slaName: any;
  constructor(public restApi: SLAKPIApiService, private _activatedRoute: ActivatedRoute,
    public adminService: AdminApiService, private userService: UserService,
    public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private toaster: ToasterService, private kpiAllHistoryComponent: KPIAllHistoryComponent, private modalService: BsModalService) {

    this._activatedRoute.queryParams.subscribe((params: Params) => {
      
      this.Qyearsla = Number(params['yearsla']);
      this.Qquatersla = Number(params['quatersla']);
      this.Qdivisionsla = Number(params['divisionsla']);
      this.QPerformance = (params['performance']!=undefined) ? Number(params['performance']) : 0;
      if (this.Qyearsla > 0) this.isback = true;
       
    });

    //To Validate User Permission
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.isDigitalDewa = (this.user.tenantDigitalUser == 'true') ? true : false;
    this.isAdmin = (this.user.role == 'Administrator') ? true : false;
    if (!this.isAdmin) {
      this.CheckUserPermission();
    }
    else {
      this.permision_add = true;
      this.permision_edit = true;
      this.permision_delete = true;
      
    }

  }
  ngOnInit() {
    this.userService.CheckLogin();
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.slaName = this.user.slaname;
    this.currentYear = this.user.currentYear;
    this.currentHalf = this.user.currentHalf;
    this.currentQuarter = this.user.currentQuarter;
    this.currentMonth = this.user.currentMonth;
    this.wellperformKPIRange = this.user.wellperformKPIRange;
    this.yearUno = this.currentYear;
    this.quarterUno = this.currentQuarter;
    this.objkpiRelease = new kpiRelease();
    //Load Default filter values
    this.loadFilterValues();
    this.loadFrequency();
    
    
  }
  //Load Frequency Values
  loadFilterValues() {
    this.spinner.show();
    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.restApi.getKPITranFilterValues(inpValue)
      .subscribe(data => {
        
        let objdata: any = data;
        this.sli_data = objdata.list_SLAMaster;
        this.division_data = objdata.list_DivisionMaster;
        this.quaterData = objdata.list_QuarterMaster;
        this.yearData = objdata.list_YearMaster;

        setTimeout(() => {
          this.yearUno = (this.Qyearsla > 0) ? this.Qyearsla : Number(this.yearUno);
          this.yearUno = (this.Qyearsla > 0) ? this.Qyearsla : Number(this.yearUno);
          this.quarterUno = (this.Qquatersla > 0) ? this.Qquatersla : Number(this.quarterUno);
          if (this.Qdivisionsla > 0)
            this.divisionUno = (this.Qdivisionsla > 0) ? this.Qdivisionsla : Number(this.Qdivisionsla);
          this.loadSlaPerformance(2); //by filter

        }, 30);

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }
  //To Validate Current User - Page Level Permission
  CheckUserPermission() {

    
    this.permision_add = true;
    this.permision_edit = true;
    this.permision_delete = true;
  }

   

 
  loadFrequency() {
    if (this.isDigitalDewa == false) {
      this.frequency_data = [];
      this.frequency_data = [
        { frequencyCode: 1, frequencyName: 'Yearly' },
        { frequencyCode: 2, frequencyName: 'Semi-annually' },
        { frequencyCode: 3, frequencyName: 'Quarterly' }
        //{ frequencyCode: 4, frequencyName: 'Monthly' }
      ];
    }

    if (this.isDigitalDewa == true || this.tenantUno == 5) {
      this.frequency_data = [];
      this.frequency_data = [
        { frequencyCode: 1, frequencyName: 'Yearly' },
        { frequencyCode: 2, frequencyName: 'Semi-annually' },
        { frequencyCode: 3, frequencyName: 'Quarterly' },
        { frequencyCode: 4, frequencyName: 'Monthly' }
      ];
    }
  }
  

  // Get SlaPerformance list
  loadSlaPerformance(condition) {
    
    this.loading = true;
    let inpValue = new slaperformance();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = condition;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.slaUno = this.slaUno ? this.slaUno:0;
    inpValue.kpiyear = this.yearUno ? this.yearUno : 0;
    inpValue.kpiquarter = this.quarterUno ? this.quarterUno : 0;
    inpValue.divisionUno = this.divisionUno ? this.divisionUno : 0;
    inpValue.frequencyUno = this.frequencyUno ? this.frequencyUno : 0;


    inpValue.half = this.currentHalf;
    inpValue.month = this.currentMonth;
    inpValue.wellperformKPIRange = this.wellperformKPIRange;
    this.restApi.getSlaPerformance(inpValue)
      .subscribe(data => {
        
       
        if (this.QPerformance > 0) {
          let objdata: any = data;
          this.slaPerformance_data = objdata.filter(s => s.bandValue == this.QPerformance);
        }
        else {
          this.slaPerformance_data = data;
        }
        const mockDataset = [];
        for (let i = 0; i < this.slaPerformance_data.length; i++) {
          mockDataset[i] = {
            id: i+1,
            slaName: this.slaPerformance_data[i].slaName,
            slaUno: this.slaPerformance_data[i].slaUno,
            year: this.slaPerformance_data[i].year,
            quarter: this.slaPerformance_data[i].quarter,
            slaPerfomancePercentage: this.slaPerformance_data[i].bandValue==0?'-': this.slaPerformance_data[i].slaPerfomancePercentage +'%',
            bandValueText: this.slaPerformance_data[i].bandValueText,
            bandValue: this.slaPerformance_data[i].bandValue,
          };
        }
        this.dataset = mockDataset;
        this.dataSearch = mockDataset;
        if (mockDataset.length > 0) {
          this.setColnDefn();
        }
        this.loading = false;
        
      },
        (error) => {
          //Called when error
          this.loading = false;
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  viewKPIHistoryAll(kpiUno: any, kpiNameEn: any) {
    this.kpiUnoSelected = kpiUno;
    this.kpinameSelected = kpiNameEn;
    this.kpiAllHistoryComponent.viewKPI(kpiUno);
    //this.KPIAllHistoryDialog.show();

  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }

  drawertoggle() {
    
    this.isToggle = (this.isToggle) ? false : true;
  }

  // Choose city using select dropdown
  onchangeSLA(e) {
    
    //alert(e.itemData.slaUno);
    this.slaUno = (e.length == 0 || e[0].value == 'All') ? 0 : e[0].value;
    this.onSelectedTab();

  }
  onchangeYear(e) {
    
    this.yearUno = ( e.length == 0 || e[0].value == 'All') ? 0 : e[0].value;
    this.onSelectedTab();
  }


  onchangeQuarter(e) {
    this.quarterUno = (e.length == 0 || e[0].value == 'All') ? 0 : e[0].value;
    this.onSelectedTab();
  }


  onchangeDivision(e) {
    this.divisionUno = (e.length == 0 || e[0].value == 'All') ? 0 : e[0].value;
    this.onSelectedTab();
  }


  onchangeFrequency(e) {
    this.frequencyUno = (e && e.length > 0 && e[0].value == 'All') ? 0 : e[0].value;
    this.onSelectedTab();
  }

  
  onSelectedTab() {   
    this.loadSlaPerformance(2); //by filter
  }


  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  exportToExcel() {
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }


  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }
  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.slaName && a.slaName.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.year && a.year.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.quarter && a.quarter.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.slaPerfomancePercentage && a.slaPerfomancePercentage.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.bandValueText && a.bandValueText.toLowerCase().includes(this.searchText.toLowerCase())));
    }
    else
      this.dataset = this.dataSearch;
  }
  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'slaName', name: this.slaName, field: 'slaName', sortable: true, width: 300,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'slaName', 'slaName'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'year', name: 'Year', field: 'year', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'year', 'year'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'quarter', name: 'Quarter', field: 'quarter', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'quarter', 'quarter'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'slaPerfomancePercentage', name: 'Performance', field: 'slaPerfomancePercentage', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'slaPerfomancePercentage', 'slaPerfomancePercentage'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'bandValueText', name: 'Bands', field: 'bandValueText', selectable: false, type: FieldType.string, filterable: true, formatter: this.bandFormatter,
        filter: {
          collection: this.uniqueArray(this.dataset, 'bandValueText', 'bandValueText'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 50,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
           


            {
              command: 'attachment-row', titleKey: 'VIEW_ROW', positionOrder: 63, title: 'Attachment',
              iconCssClass: 'fa fa-files-o', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {

                let rdata: any = args.dataContext;
                //if (rdata.attachmentCount < 1) {
                //  // Swal.fire('Error', 'No Data Available', 'info');
                //  this.toaster.show('error', 'Error', 'No Data Available');
                //  return;
                //}
                this.selectedSLAUno = rdata.slaUno;
                this.getFiles(rdata.slaUno)
                this.modalRef = this.modalService.show(
                  this.attachmentTemplate,
                  Object.assign({}, {
                    class: 'gray modal-lg',
                    backdrop: true,
                    keyboard: true,
                    focus: true,
                    show: false,
                    ignoreBackdropClick: true,
                    animated: true
                  })
                );

              },
              // only show command to 'Delete Row' when the task is not completed

            }


          ],
        }
      }
    ]


  }

  bandFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    if (dataContext.bandValue == '1')
      return `<div class="bg-grey-progress" > <span class="green-bar"></span></div>`;
    if (dataContext.bandValue == '2')
      return `<div class="bg-grey-progress" > <span class="red-bar"></span></div>`;
    if (dataContext.bandValue != 1 && dataContext.bandValue != 2 && dataContext.bandValue == 0)
      return `<div class="bg-grey-progress" > <span class="bluedark-bar"></span></div>`;
  };
 
  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };

  backClick() {
    this.router.navigate(['/sladashboard/general'], { queryParams: { yearsla: this.yearUno, quatersla: this.quarterUno } });

  }
  getFiles(slaUno: string) {
    this.AttachmentList = null;
    let inpValue = new filecontent();
    inpValue.masterUNo = slaUno;
    inpValue.itemUNo = '0';
    inpValue.userUno = this.login_UserID;
    this.spinner.show();
    //this.slaUno = slaUno;
    
    this.restApi.SLA_FileSelect(inpValue)
      .subscribe(data => {
        
        this.AttachmentList = data;
        this.fileItemCount = (this.AttachmentList != undefined && this.AttachmentList != null) ? this.AttachmentList.length : 0;
        this.spinner.hide();

      },
        (error) => {
          this.spinner.hide();
        }
      ).add(() => {
        this.spinner.hide();
      });
  }

  AttachmentDownload(id: any, name: string) {
    let inpValue = new filecontent();
    inpValue.masterUNo = this.selectedSLAUno;
    inpValue.itemUNo = id;
    inpValue.userUno = this.login_UserID;
    this.spinner.show();
    this.restApi.SLA_Filedownload(inpValue).subscribe(
      data => {
        
        this.spinner.hide();
        if (data != null) {
          
          if (window.navigator.msSaveOrOpenBlob) //IE & Edge
          {
            //msSaveBlob only available for IE & Edge
            window.navigator.msSaveBlob(data, name);
          }
          else //Chrome & FF
          {
            var url = window.URL.createObjectURL(data);
            var a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url;
            a.download = name;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove(); // remove the element
          }

        }
        else {
          this.spinner.hide();
          //Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong.');
        }
      },
      error => {
        //Swal.fire('Error', 'Something went wrong', 'error')
        this.toaster.show('error', 'Error', 'Something went wrong.');
        this.spinner.hide();
      },
      () => {
        // 'onCompleted' callback.
        this.spinner.hide();

      }
    );

  }

  getFileIconClass(fileTitle: string) {

    if (fileTitle == '' || fileTitle == null)
      return "fa fa-file";

    var rtnClass = "fa fa-file";
    var strTitle = (fileTitle.indexOf('.') > 0) ? fileTitle.split('.')[1].toLowerCase() : 'unknown';

    switch (strTitle) {
      case 'txt':
        rtnClass = "fa fa-file-o";
        break;
      case 'doc':
        rtnClass = "fa fa-file-word-o";
        break;
      case 'docx':
        rtnClass = "fa fa-file-word-o";
        break;
      case 'xls':
        rtnClass = "fa fa-file-excel-o";
        break;
      case 'xlsx':
        rtnClass = "fa fa-file-excel-o";
        break;
      case 'pdf':
        rtnClass = "fa fa-file-pdf-o";
        break;
      case 'gif':
      case 'jpeg':
      case 'jpg':
      case 'png':
        rtnClass = "fa fa-file-picture-o";
        break;
      case 'mp3':
        rtnClass = "fa fa-file-audio-o";
        break;
      case 'mp4':
      case 'mpeg':
      case 'mpg':
      case 'avi':
        rtnClass = "fa fa-file-video-o";
        break;
      default:
        rtnClass = "fa fa-file";
        break;
    }

    return rtnClass;

  }
}


